import type { GlobalEventProperties } from "@v2/features/infra/analytics/events";

import * as React from "react";

import {
  selectDraftElementId,
  selectDraftElementName,
  selectDraftElementType,
  selectDraftElementUseSectionSettings,
  selectDraftElementVersion,
  selectUpdatesSinceLastRequestFinished,
} from "@v1/reducers/core-reducer";
import { useEditorStore } from "@v1/store/store";

type V1AnalyticsGetter = () => Partial<GlobalEventProperties>;

export const useV1AnalyticsGetter = (): V1AnalyticsGetter => {
  const store = useEditorStore();

  return React.useCallback((): Partial<GlobalEventProperties> => {
    const state = store.getState();
    return {
      elementId: selectDraftElementId(state),
      elementName: selectDraftElementName(state),
      elementType: selectDraftElementType(state),
      elementVersion: selectDraftElementVersion(state),
      elementSectionSettingsEnabled: Boolean(
        selectDraftElementUseSectionSettings(state),
      ),
      unsavedUpdates: selectUpdatesSinceLastRequestFinished(state),
    };
  }, [store]);
};
